import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CustomTabs } from "../../Components/CustomTabs";

import StockRportView from "./StockReport/StockRportView";
import StocklimitView from "../Invoice/Rework Entry/StockLimit/StocklimitView";

export const AllInventoryReportTabs = () => {
  const userData = useSelector((state) => state.auth.profile);

  const isInGroups = (...groups) =>
    groups.some((group) => userData.groups.includes(group));

  const tabs = [
    {
      label: "Stock Alert",
      roles: [
        "Director",
        "Accounts",
        "Operations & Supply Chain Manager",
        "Stores",
        "Production",
        "QA",
      ],
      component: <StocklimitView />,
    },
    {
      label: "Stock Report",
      roles: [
        "Director",
        "Accounts",
        "Operations & Supply Chain Manager",
        "QA",
      ],
      component: <StockRportView />,
    },
  ];

  const visibleTabs = tabs.filter((tab) => isInGroups(...tab.roles));

  // Simplified active tab state to always start with the first item of visibleTabs if available
  const [activeTab, setActiveTab] = useState(0);

  const onTabChange = (newIndex) => {
    setActiveTab(newIndex);
  };

  return (
    <>
      <CustomTabs
        tabs={visibleTabs.map((tab) => ({
          label: tab.label,
          index: tab.index,
        }))}
        activeTab={activeTab}
        onTabChange={onTabChange}
      />
      {visibleTabs.length > 0 && visibleTabs[activeTab] ? (
        <div>{visibleTabs[activeTab].component}</div>
      ) : null}
    </>
  );
};
